import { useState } from "react";
import NewsCard from "../../Molecules/NewsCard/NewsCard";
import { Button } from "../../Atoms/Button/Button";
import usePosts from "../../../hooks/usePosts";
import Loader from "../../Atoms/Loader/Loader";
import content from "../../Pages/AllNews/content"
import { useLanguageCtx } from "../../../store/providers/LanguageContext";

const AllNewsSection = () => {
	const [showButton, setShowButton] = useState(true);
	const { loading, posts, changePaginationNumb, paginationNumb } =
		usePosts("posts", 6, setShowButton);
	const {language} = useLanguageCtx();

	return (
		<div className="top-space-section max-width ">
			<h2 className="t2 center-text">{content[language].bold_text}</h2>
			<div
				className={`flex wrap space-around top-space-section ${
					!showButton && "bottom-space-section"
				}`}
			>
				{loading && paginationNumb === 0 ? (
					<div className="bottom-space-section">
						<Loader />
					</div>
				) : (
					posts.map((post, index) => {
						const date = new Date(post.createdAt).toLocaleDateString();
						return (
							<NewsCard
								key={index}
								date={date}
								post={post}
								linkRoute={`/noticias/${post.slug}`}
								linkText={content[language].link_text}
							/>
						);
					})
				)}
			</div>
			{loading && paginationNumb > 0 && (
				<div className="top-space-section">
					<Loader />
				</div>
			)}
			{showButton && posts.length > 0 && (
				<div className="allNewsSection-button-container flex center-content-items top-space-section bottom-space-section">
					<Button
						type="button light-blue outline"
						content={content[language].final_button_text}
						clickHandler={changePaginationNumb}
					/>
				</div>
			)}
		</div>
	);
};

export default AllNewsSection;
